<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("auto.linkedinUpdatePageTitle") }}</div>
            <div class="subtitle">{{ $t("auto.linkedinManageChannelSubtitle") }}</div>
        </div>

        <template v-if="shouldShowIframe">
            <div class="onboarding-wrapper">
                <SupsisButton type="primary" class="integration-button" @click="openOnboardingLink" large primary>
                    {{ $t("auto.linkedinRunIntegration") }}
                </SupsisButton>

                <SupsisButton class="integration-button" @click="connectSupportTeamRequest" xlarge ghost icon="help">
                    {{ $t("auto.getHelp") }}
                </SupsisButton>

                <a-alert
                    class="mt-4"
                    message="Bilgilendirme"
                    description="Eğer Linkedin hesabınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir."
                    type="info"
                    show-icon
                />
            </div>
        </template>
        <template v-else-if="shouldShowReconnect">
            <div class="onboarding-wrapper">
                <SupsisButton
                    type="primary"
                    class="integration-button"
                    @click="openOnboardingLink('reconnect')"
                    large
                    primary
                >
                    {{ $t("auto.linkedinReconnect") }}
                </SupsisButton>

                <SupsisButton class="integration-button" @click="connectSupportTeamRequest" xlarge ghost icon="help">
                    {{ $t("auto.getHelp") }}
                </SupsisButton>

                <a-alert
                    class="mt-4"
                    message="Bilgilendirme"
                    description="Eğer Whatsapp V3 hesabınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir."
                    type="info"
                    show-icon
                />
            </div>
        </template>
        <template v-else>
            <a-form>
                <div class="form-wrapper">
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.channelName") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.channelName')"
                            v-model="clone.name"
                            v-validate="'required'"
                            name="channelName"
                        />
                    </div>
                </div>
            </a-form>
            <ChannelForwardSetting :channel="clone" @input="(c) => (clone = c)" />
            <div class="form-footer">
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                        {{ $t("message.update") }}
                    </a-button>
                </div>
            </div>
        </template>

        <div v-if="showIframe" class="iframe-overlay">
            <div class="iframe-container">
                <div class="iframe-header">
                    <span>{{ $t("auto.linkedinIntegrationSectionTitle") }}</span>
                    <a-button class="close-button" @click="closeIframe" icon="close" />
                </div>
                <iframe :src="iframeUrl" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VisibilityChanger from "../../WhatsappV1/VisibilityChanger.vue";
import _ from "lodash";
import log2 from "../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import ChannelForwardSetting from "../../IntegrationChannelsItem/ChannelForwardSetting.vue";
import { publishMessage, SystemMessageTypes } from "../../../../utils/systemPubSub";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { socketMessageStream } from "../../../../utils/socketStream";
import { filter } from "rxjs/operators";
import { getReconnectChannelURL } from "../../../../api/channel";

const log = log2("UpdateDetail.vue");
export default Vue.extend({
    name: "UpdateDetail",
    components: { VisibilityChanger, ChannelForwardSetting, SupsisButton },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
            showStories: !!this.value.forward.story,
            showIframe: false,
            iframeUrl: "",
            popupWindow: null,
            cancels: [],
            reconnectAccountUrl: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
        rawStatus() {
            return this.$_.get(this.value, "payload.sources.0.status", "WAITING");
        },
        shouldShowIframe() {
            return this.clone.onboard && this.clone.onboard.live === false && this.clone.onboard.onboardLink;
        },
        shouldShowReconnect() {
            return this.rawStatus === "CREDENTIALS";
        },
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
        }),
        listenSocket() {
            const sub1 = socketMessageStream.pipe(filter((x) => x.cmd === "unipile_channel_created")).subscribe((x) => {
                this.$message.success("Linkedin Account connected successfully");
                this.listChannels();
                this.showIframe = false;
                if (this.popupWindow) {
                    this.popupWindow.close();
                }
            });
            const sub2 = socketMessageStream.pipe(filter((x) => x.cmd === "unipile_channel_sync")).subscribe((x) => {
                this.$message.success("Linkedin Account updated successfully");
                this.listChannels();
                this.showIframe = false;
                if (this.popupWindow) {
                    this.popupWindow.close();
                }
            });
            this.cancels.push(() => {
                sub1.unsubscribe();
                sub2.unsubscribe();
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const isChanged = !_.isEqual(this.value, this.clone);
                if (!isChanged) {
                    return;
                }
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("whatsapp_business_api.channelUpdatedSucs"));
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("whatsapp_business_api.faieldUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        openOnboardingLink(type = "onboard") {
            try {
                const url = new URL(type === "reconnect" ? this.reconnectAccountUrl : this.clone.onboard.onboardLink);
                const width = 1000;
                const height = 800;
                const left = (window.screen.width - width) / 2;
                const top = (window.screen.height - height) / 2;

                const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`;
                this.popupWindow = window.open(url.toString(), 'LinkedinOnboarding', features);

                const checkWindow = setInterval(() => {
                    if (this.popupWindow && this.popupWindow.closed) {
                        clearInterval(checkWindow);
                        this.handlePopupClose();
                    }
                }, 500);
            } catch (error) {
                console.error("Geçersiz URL:", error);
                this.$message.error(this.$t("auto.invalidLinkContactSupport"));
            }
        },
        handlePopupClose() {
            this.popupWindow = null;
            this.listChannels();
        },
        connectSupportTeamRequest() {
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {
                initialMessage: "/linkedin-yardım",
                largeMode: true,
            });
        },
        closeIframe() {
            this.showIframe = false;
            this.iframeUrl = "";
        },
        getReconnectURL() {
            getReconnectChannelURL(this.value._id).then((data) => {
                if (data.reconnectUrl) {
                    this.reconnectAccountUrl = data.reconnectUrl;
                }
            });
        },
    },
    mounted() {
        this.getReconnectURL();
        this.listStories();
        this.listenSocket();
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
    beforeDestroy() {
        this.cancels.forEach((c) => c());
        if (this.popupWindow && !this.popupWindow.closed) {
            this.popupWindow.close();
        }
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .onboarding-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70vh;
        gap: 10px;
        flex-direction: column;

        .integration-button {
            padding: 20px 40px;
            height: auto;
            font-size: 24px;
            line-height: 1.5;
            border-radius: 12px;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.05);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            &:active {
                transform: scale(0.98);
            }
        }
    }

    .iframe-overlay {
        display: none;
    }
}
</style>
